import { $apiV2 } from "../config/api";

export const listFilterTemplates = async (pageKey) => {
  const response = await $apiV2.get(
    `/users/filter-templates?page_key=${encodeURIComponent(pageKey)}`
  );

  return response?.data || [];
};

export const getFilterTemplate = async (id) => {
  const response = await $apiV2.get(`/users/filter-templates/${id}`);
  return response?.data;
};

export const createFilterTemplate = async (payload) => {
  const response = await $apiV2.post(`/users/filter-templates`, payload);
  return response?.data;
};

export const updateFilterTemplate = async (id, payload) => {
  const response = await $apiV2.put(`/users/filter-templates/${id}`, payload);
  return response?.data;
};

export const deleteFilterTemplate = async (id) => {
  const response = await $apiV2.delete(`/users/filter-templates/${id}`);
  return response?.data;
};
